/* eslint-disable vue/no-unused-components */
export const EUMGridConfig = {
    list:"Transfer",
    grid: {
		gridId: 'TestPdf',
		checkbox: true,
		edit: false,
		delete: false,
		pageSize: 100,
		groupable: true
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status<sup>[1]</sup>',
			width: 100,
			hidden: false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program<sup>[3]</sup>',
			width: 150,
			hidden: false,
			readOnly:true
        },
        SenderId: {
			class: 'lookup',
			dataName: 'SenderId',
			type: 'number',
			title: 'Transferor Id',
			width: 100,
			hidden: true
		},
		SenderFullName: {
			class: 'lookup',
			dataName: 'Sender/FullName',
			type: 'string',
			title: 'Transferor',
			width: 150,
			hidden: false,
			readOnly: true
		},
		ReceiverId: {
			class: 'lookup',
			dataName: 'ReceiverId',
			type: 'number',
			title: 'Transferee Id',
			width: 100,
			hidden: true
		},
		ReceiverFullName: {
			class: 'lookup',
			dataName: 'Receiver/FullName',
			type: 'string',
			title: 'Transferee<sup>[2]</sup>',
			width: 150,
			hidden: false,
			readOnly: true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 100,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 100,
			hidden: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'Unit Pool',
			width: 100,
			hidden: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Unit',
			width: 100,
			hidden: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'BusinessEvent',
			width: 100,
			hidden: true
		}
	}
}